export default __webpack_public_path__ + "static/media/BgModalOperator.9febb380.png";